<template>
    <div class="ui-section">
        <div class="inner">
            <div class="cols" ref="content">
                <div class="col-3-1 left" v-html="left"></div>
                <div class="col-3-1 center" v-if="center" v-html="center"></div>
                <div class="col-3-1 right" v-if="center" v-html="right"></div>
                <div class="col-3-2 right" v-else v-html="right"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ui-section',

    props: {
        left: {
            type: String,
            default: ''
        },
        center: {
            type: String,
            default: ''
        },
        right: {
            type: String,
            default: ''
        },
    },
    
    mounted() {
        let links = this.$refs.content.querySelectorAll('a');

        if (links.length !== 0) {
            links.forEach(el => {
                let href = el.getAttribute('href');
                if (!this.isExternal(href)) {
                    el.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.$router.push({ path: href.replace(window.globals.home_url, '') });
                    });
                }
            });
        }
    },
}

</script>

<style lang="scss">
    .ui-section {
        background: var(--yellow);
        padding: var(--padding-x3) 0;

        img {
            max-width: 100%;
            max-height: 80rem;
            display: block;
            width: auto;
            height: auto;
        }

        .wp-caption {
            max-width: 100%;

            img {
                margin-bottom: var(--padding-x2);
                display: block;
            }
        }

        .wp-caption-text {
            width: 100%;
            color: white;
            font-weight: bold;
            font-family: var(--font);
        }

        .left {
            font-size: var(--title-size);
            font-weight: bold;
            text-transform: lowercase;
            line-height: 1.1;

            h3 {
                color: white;
            }

            h2,h3 {
                margin-bottom: .5rem;
            }
        }

        // .col-3-2 {
        //     columns: 2;
        //     column-gap: var(--padding);
        // }

        .right,
        .center {
            font-family: 'CenturySchoolbookPro', Courier, monospace;
            font-size: var(--base-size);

            i,
            em {
                font-family: 'CenturySchoolbookPro-Italic', Courier, monospace;
                font-style: normal;
            }

            b,
            strong,
            h1,h2,h3,h4,h5 {
                color: white;
                font-family: var(--font);
                font-weight: bold;
            }

            h1,h2,h3,h4,h5,
            div,p {
                margin: 0 0 var(--padding-x2);
            }

            a {
                color: white;
                font-family: var(--font);
                font-weight: bold;

                &:hover {
                    color: var(--font-color);
                }
            }
        }

        &.post-section {
            background: var(--bg-color);
            padding: var(--padding-x3) 0;

            .left {
                font-weight: bold;

                h3 {
                    color: var(--gray);
                }
            }

            .wp-caption-text {
                color: var(--gray);
            }

            .right,
            .center {
                font-family: var(--font);
                font-weight: bold;

                h1,h2,h3 {
                    font-size: var(--title-size);
                    color: var(--font-color);
                }

                a {
                    color: var(--yellow);

                    &:hover {
                        color: var(--font-color);
                    }
                }
            }
        }
    }

    @media only screen and (max-width: 780px) {
        .ui-section {
            padding: var(--padding) 0;

            .wp-caption {

                img {
                    margin-bottom: var(--padding);
                    max-height: unset;
                }
            }

            img {
                max-height: unset;
            }
            
            .right,
            .center {
                padding-top: var(--padding);


                h1,h2,h3,h4,h5,
                div,p {
                    margin: 0 0 var(--padding);
                }


            }

            &.post-section {
                padding: var(--padding) 0;
            }
        }
    }
</style>